<template>
    <div class="bekrafta" id="ordersummary-confirm"> 
      <h1 class="bekrafta__title">Snart klar!</h1>
      <p class="bekrafta__subtitle">Allt du behöver göra är att kontrollera att dina uppgifter stämmer. </p>
      <ul class="summary">
      
          <li class="summary__item" v-if="$root.price_type==='fixed'"><span><b>Ditt elavtal</b></span><span><b>{{$root.strings[$root.price_type]}} elpris </b>{{$root.publishCommitment()}}</span></li>
          <li class="summary__item" v-if="$root.price_type==='variable'"><span><b>Ditt elavtal</b></span><span><b>{{$root.strings[$root.price_type]}} elpris </b></span></li>
          <li class="summary__item" v-if="$root.price_type==='mix5050'"><span><b>Ditt elavtal</b></span><span><b>Mix 50/50</b></span></li>
          <li class="summary__item" v-if="$root.price_type==='spotavtal'"><span><b>Ditt elavtal</b></span><span><b>Spotavtal</b></span></li>

          <li class="summary__itemhighlight" v-if="$root.price_type==='spotavtal'">Tills dess att bytet till kvartsmätning är klart får du ett rörligt elpris under tiden.</li>
          <li class="summary__item"><span><b>Önskad avtalsstart</b></span><span><b>{{$root.contract.date}}</b></span></li>
          <li class="summary__item" v-if="$root.searchMovingIn"><span><b>Inflytt</b></span><span><b>Ja</b></span></li>
          
          <li class="summary__item"><span><b>Årsförbrukning</b></span><span><b>{{$root.watts}}</b> kWh</span></li>
  
          <!--<li class="summary__item"><span><b>Elpris</b></span><span><b>{{$root.net_price}}</b> öre/kWh</span></li>
          <li class="summary__item"><span><b>Moms</b></span><span><b>{{$root.moms}}</b> öre/kWh</span></li>
          <li class="summary__item"><span><b>Total elpris</b></span><span><b>{{$root.price}}</b> öre/kWh</span></li>-->

          <li class="summary__item"><span><b>{{$root.getSelectedEnergySourceTitleObject().title}}</b>{{$root.getSelectedEnergySourceTitleObject().extra}}</span> <span><b>{{$root.getSelectedEnergySourcePriceText(true)}}</b></span></li>

          <!-- Mix 50/50 -->
          <li class="summary__item" v-if="$root.price_type==='mix5050'"><span><b>Fast elpris inkl. elcertifikatkostnad <small>för 50% av din förbrukning</small></b></span> <span>{{$root.fixed_months_contract(12).price}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='mix5050'"><span><b>Medelspotpris ({{$root.timspot_contract().monthName}}) <small>för 50% av din förbrukning</small></b></span> <span>{{$root.round_value($root.movable_contract().price)}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='mix5050'"><span><b>Rörligt elcertifikat <small>för 50% av din förbrukning</small></b></span> <span>{{$root.round_value($root.movable_contract().elCert)}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='mix5050'"><span><b>Fast påslag <small>för 50% av din förbrukning</small></b></span> <span>{{$root.round_value($root.movable_contract().addon)}} öre/kWh</span></li>
          <!--<li class="summary__item" v-if="$root.price_type==='mix5050'"><span>1<b>00% fossilfri  el</b></span> <span>0.00 öre/kWh</span></li>-->
          <li class="summary__item" v-if="$root.price_type==='mix5050'"><span><b>Moms</b></span> <span>{{$root.getVATMix5050()}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='mix5050'"><span><b>Totalt elpris</b> (inkl. moms exkl. fast avgift)</span> <span><b>{{$root.getTotalMix5050Price($root.watts, true)}}</b> öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='mix5050'"><span><b>Fast avgift</b> (inkl. moms)</span> <span><b>{{$root.round_value($root.movable_contract().monthlyFee)}}</b> kr/mån</span></li>
          <li class="summary__item" v-if="$root.price_type==='mix5050'"><span><b>Totalt elpris</b> (inkl. moms och fast avgift)</span> <span><b>{{$root.getTotalMix5050Price($root.watts, false)}}</b> öre/kWh</span></li>
  
          <!-- Fast elpris -->
          <li class="summary__item" v-if="$root.price_type==='fixed'"><span><b>Fast elpris inkl. elcertifikatkostnad</b></span> <span>{{$root.fixed_contract().price}} öre/kWh</span></li>
          <!--<li class="summary__item" v-if="$root.price_type==='fixed'"><span>1<b>00% fossilfri  el</b></span> <span>0.00 öre/kWh</span></li>-->
          <li class="summary__item" v-if="$root.price_type==='fixed'"><span><b>Moms</b></span> <span>{{$root.round_value($root.fixed_contract().price*.25)}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='fixed'"><span><b>Totalt elpris</b> (inkl. moms exkl. fast avgift)</span> <span><b>{{$root.getTotalFixedPrice($root.watts, true)}}</b> öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='fixed'"><span><b>Fast avgift</b> (inkl. moms)</span> <span><b>{{$root.round_value($root.fixed_contract().monthlyFee)}}</b> kr/mån</span></li>
          <li class="summary__item" v-if="$root.price_type==='fixed'"><span><b>Totalt elpris</b> (inkl. moms och fast avgift)</span> <span><b>{{$root.getTotalFixedPrice($root.watts, false)}}</b> öre/kWh</span></li>
  
          <!-- Rörligt elpris -->
          <li class="summary__item" v-if="$root.price_type==='variable'"><span><b>Rörligt elpris</b> (medelpris {{$root.movable_contract().monthName}})</span> <span>{{$root.round_value($root.movable_contract().price)}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='variable'"><span><b>Rörligt elcertifikat</b></span> <span>{{$root.round_value($root.movable_contract().elCert)}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='variable'"><span><b>Fast påslag</b></span> <span>{{$root.round_value($root.movable_contract().addon)}} öre/kWh</span></li>
          
          <!--<li class="summary__item" v-if="$root.price_type==='variable'"><span><b>100% fossilfri el</b></span> <span>0.00 öre/kWh</span></li>-->
          
          <li class="summary__item" v-if="$root.price_type==='variable'"><span><b>Moms</b></span> <span>{{$root.round_value(($root.movable_contract().elCert + $root.movable_contract().addon + $root.movable_contract().price)*.25)}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='variable'"><span><b>Totalt elpris</b> (inkl. moms exkl. exkl. fast avgift)</span> <span><b>{{$root.getTotalVariablePrice($root.watts, true)}}</b> öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='variable'"><span><b>Fast avgift</b> (inkl. moms)</span> <span><b>{{$root.round_value($root.movable_contract().monthlyFee)}}</b> kr/mån</span></li>
          <li class="summary__item" v-if="$root.price_type==='variable'"><span><b>Totalt elpris</b> (inkl. moms och fast avgift)</span> <span><b>{{$root.getTotalVariablePrice($root.watts)}}</b> öre/kWh</span></li>
  
          <!-- spotavtal elpris -->
          <li class="summary__item" v-if="$root.price_type==='spotavtal'"><span><b>Spotpris</b> ({{$root.timspot_contract().monthName}})</span> <span>{{$root.round_value($root.timspot_contract().price)}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='spotavtal'"><span><b>Rörlig inköpskostnad</b></span> <span>{{$root.round_value($root.timspot_contract().purchaseCost)}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='spotavtal'"><span><b>Rörligt elcertifikat</b></span> <span>{{$root.round_value($root.timspot_contract().elCert)}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='spotavtal'"><span><b>Fast påslag</b></span> <span>{{$root.round_value($root.timspot_contract().addon)}} öre/kWh</span></li>
          
          <li class="summary__item" v-if="$root.price_type==='spotavtal'"><span><b>Moms</b></span> <span>{{$root.round_value((this.$root.timspot_contract().purchaseCost + $root.timspot_contract().elCert + $root.timspot_contract().addon + $root.timspot_contract().price)*.25)}} öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='spotavtal'"><span><b>Totalt elpris</b> (inkl. moms exkl. fast avgift)</span> <span><b>{{$root.getTotalSpotPrice($root.watts, true)}}</b> öre/kWh</span></li>
          <li class="summary__item" v-if="$root.price_type==='spotavtal'"><span><b>Fast avgift</b> (inkl. moms)</span> <span><b>{{$root.round_value($root.timspot_contract().monthlyFee)}}</b> kr/mån</span></li>
          <li class="summary__item" v-if="$root.price_type==='spotavtal'"><span><b>Totalt elpris</b> (inkl. moms och fast avgift)</span> <span><b>{{$root.getTotalSpotPrice($root.watts)}}</b> öre/kWh</span></li>

          <li class="summary__item" v-if="$root.bonus_data!=null && $root.bonus_data.discountMonthlyPriceIncVAT != null"><span><b>Rabatt fast avgift under {{$root.bonus_data.discountMonthlyPriceMonths}} månader</b> (inkl. moms)</span> <span><b>-{{$root.round_value($root.bonus_data.discountMonthlyPriceIncVAT)}}</b> {{$root.bonus_data.discountMonthlyPriceUnit}}</span></li>


            <li class="summary__item" v-if="$root.prisbevakning"><span><b>Prisbevakning </b>({{$root.prisbevakning_option}} öre/kWh)</span><span><b>10</b> kr/mån</span></li>
            <li class="summary__item" v-if="$root.barncancerfonden"><span><b>Barncancerfonden</b></span><span><b>10</b> kr/mån</span></li>
            <!-- <li class="summary__item" v-if="$root.solvatten"><span><b>Solvatten</b></span><span><b>10</b> kr/mån</span></li> -->
            <!-- <li class="summary__item" v-if="$root.energysource==='fossilfriel'"><span><b>Fossilfri el</b></span><span><b>0</b> kr/mån</span></li>
            <li class="summary__item" v-if="$root.miljoval"><span><b>Bra Miljöval</b> ({{$root.timspot_contract().monthName}})</span><span><b>25</b> kr/mån</span></li>
            <li class="summary__item" v-if="$root.energysource==='vattenkraft'"><span><b>Vattenkraft</b></span><span><b>0</b> kr/mån</span></li>
            <li class="summary__item" v-if="$root.energysource==='vindkraft'"><span><b>Vindkraft</b></span><span><b>0</b> kr/mån</span></li>
            <li class="summary__item" v-if="$root.energysource==='karnkraft'"><span><b>Kärnkraft</b></span><span><b>0</b> kr/mån</span></li>
            <li class="summary__item" v-if="$root.energysource==='bramiljoval'"><span><b>Bra miljöval</b> ({{$root.timspot_contract().monthName}})</span><span><b>10</b> öre/kWh</span></li> -->

            <li class="summary__item"><span><b>Din uppskattade kostnad</b></span><span><b>{{$root.prettyT($root.final_price)}}</b> kr/år</span></li>
            <li class="summary__item" v-if="$root.bonus_code"><span><b>Bonuskod</b></span><span><b>{{$root.bonus_code}}</b></span></li>
      </ul>
      <h2 class="bekrafta__block-title">Dina uppgifter</h2>
      <ul class="summary">
        <li class="summary__item"><span><b>Namn</b></span><span>{{$root.name}} {{$root.surname}}</span></li>
        <li class="summary__item"><span><b>Personnummer</b></span><span>{{$root.personnummer}}</span></li>
        <li class="summary__item"><span><b>Mobilnummer</b></span><span>{{$root.phone}}</span></li>
        <li class="summary__item"><span><b>E-post</b></span><span>{{$root.email}}</span></li>
        <li class="summary__item"><span><b>Du vill ha el till</b></span><span>{{$root.address}} {{$root.postal_code}} {{$root.location}}</span></li>
        <li class="summary__item" v-if="!$root.invoice_address_same_as_property"><span><b>Fakturaadress</b></span><span>{{$root.invoice_address}} {{$root.invoice_postal_code}} {{$root.invoice_location}}</span></li>
  
        <li class="summary__item"><span><b>Kundinfo</b></span><span>{{$root.getCustomerTypeInfo()}}</span></li>

        <li class="summary__item"><span><b>Anläggnings-id</b></span><span>{{$root.construction_id}}</span></li>
        <li class="summary__item"><span><b>Områdes-id</b></span><span>{{$root.territory_id}}</span></li>

        <!--<li class="summary__item" v-if="$root.old_customer_type && $root.providing_cunstruction_and_territory_id"><span><b>Anläggnings-id</b></span><span>{{$root.construction_id}}</span></li>
        <li class="summary__item" v-if="$root.old_customer_type && $root.providing_cunstruction_and_territory_id"><span><b>Områdes-id</b></span><span>{{$root.territory_id}}</span></li>
        <li class="summary__item" v-if="$root.old_customer_type && $root.not_providing_cunstruction_and_territory_id"><span><b>Anläggningsnummer</b></span><span>Jag vill att Borås Elhandel hämtar mina uppgifter</span></li>-->
        
      </ul>
      <form @submit.prevent="submit">
        <div class="betalsatt__block">
          <h2>Olika betalningsalternativ</h2>
          <p>Hos oss kan du betala via vanlig pappersfaktura, E-faktura, Autogiro eller Kivra. Har du Kivra så kommer fakturan per automatik dit, annars är pappersfakturan vårt standarval. Du kan enkelt byta till E-faktura eller Autogiro via din internetbank.</p>
          <!--<label class="checkbox autogiro betalsatt__field-content betalsatt__field-label">
            <input type="checkbox" class="checkbox__field" v-model="$root.autogiro">
            <span class="checkbox__label">Jag vill ha en blankett för Autogiro hemskickad</span>
          </label>-->
        </div>
      </form>
      <div class="bekrafta__supports" v-if="$root.barncancerfonden || $root.miljoval">
        <p class="bekrafta__support" v-if="$root.barncancerfonden">
          Tack för att du väljer att stödja
          <img src="@/assets/images/barncancerfonden.png" alt="Barncancerfonden">
        </p>
        <p class="bekrafta__support" v-if="$root.miljoval">
          Tack för att du väljer att stödja
          <img src="@/assets/images/miljoval.jpg" alt="Bra Miljöval">
        </p>
      </div>
      <p>
        <a href="files/boras-elhandels-sammanfattning-av-avtalsvillkor.pdf" target="_blank">Här kan du se en sammanfattning av våra avtalsvillkor</a>
      </p>
      <h2>Godkänn villkor</h2>
      <p class="bekrafta__terms-text">
          <!--Jag har läst och godkänt Borås Elhandels särskilda avtalsvillkor samt branschens allmänna avtalsvillkor.<br>-->
          <a href="https://www.boraselhandel.se/avtalsvillkor/" target="_blank">Borås Elhandels särskilda avtalsvillkor</a><br>
          <a href="https://www.boraselhandel.se/avtalsvillkor/" target="_blank">Allmänna villkor EL 2012 K/N</a><br>
      </p>
      <label class="checkbox">
        <input type="checkbox" class="checkbox__field" required v-model="$root.terms">
        <span class="checkbox__label">{{ $root.terms_text }}</span>
      </label>

      <p class="bekrafta__terms-text" v-if="$root.showTermsRegret()">
        Information om konsumenträtt, klagomål, rådgivning eller hjälp vid tvistlösning samt oberoende energirådgivning finns på <a href="https://boraselhandel.se/konsumentratt/" target="_blank">https://boraselhandel.se/konsumentratt/</a>. Information går också att få via vår kundsupport.        
      </p>

      <label class="checkbox" v-if="$root.showTermsRegret()">
        <input type="checkbox" class="checkbox__field" required v-model="$root.terms_regret">
        <span class="checkbox__label">{{ $root.terms_regret_text }}</span>
      </label>


      <div class="bekrafta__sign" v-bind:class="{disabled : !$root.terms || ($root.showTermsRegret() && !$root.terms_regret) }">
        <h3>Signera med BankID</h3>
        <div class="button-bankId" v-on:click="banikd('MobileBankID')"><BankId /><Arrow /><div class="button-bankId-text">Mobilt BankID</div></div>
        <div class="button-bankId" v-on:click="banikd('BankID')"><BankId /><Arrow /><div class="button-bankId-text">BankID</div></div>
      </div>
  
      <!--<form @submit.prevent="$root.send" class="bekrafta__send">
        <button type="submit" class="button bekrafta__send-submit" :disabled="!$root.terms">Slutför beställningen</button>
      </form>-->
      <p class="bekrafta__disclaimer" v-if="!$root.showTermsRegret()">
        Information om konsumenträtt, klagomål, rådgivning eller hjälp vid tvistlösning samt oberoende energirådgivning finns på <a href="https://boraselhandel.se/konsumentratt/" target="_blank">https://boraselhandel.se/konsumentratt/</a>. Information går också att få via vår kundsupport.
      </p>
      <p class="bekrafta__disclaimer" v-if="$root.showTermsRegret()" style="margin-bottom:10em;display:inline-block;">
        &nbsp;&nbsp;
      </p>
    </div>
  </template>
  <script>
      export default {
          mounted() {
            //document.getElementsByClassName('bekrafta')[0].scrollIntoView();
            document.getElementsByClassName('bekrafta')[0].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
          },
          methods: {
              banikd(bankid) {
                let isDisabled = !this.$root.terms || (this.$root.showTermsRegret() && !this.$root.terms_regret);

                  if(!isDisabled) {
                      this.$root.sign.requestType = bankid;
                      //this.$router.push({ name: 'signera' })
                      this.$root.tagSetEditMode('bankidsign');
                      this.$root.flowString += 'ordersummary';
                  }
              }
          }
      }
  </script>
<style lang="scss">
.bekrafta {
  &__title {
    text-align: center;
    margin: 0;
    @include font-primary(bold);
    @include media('>lg') {
      font-size: rem(56);
    }
    @include media('<=lg') {
      font-size: rem(47);
    }
  }
  &__subtitle {
    text-align: center;
    @include font-primary(roman);
    margin: 0 0 rem(22);
    font-size: rem(16);
  }
  &__block-title {
    float: left;
    @include font-primary(bold);
    margin: 0 0 rem(12);
    color: $secondary-text-color;
    @include media('>lg') {
      font-size: rem(22);
    }
    @include media('<=lg') {
      font-size: rem(18);
    }
  }
  &__edit {
    float: right;
    color: $primary-color;
    position: relative;
    padding-right: 1.6em;
    font-size: rem(16);
    svg {
      position: absolute;
      right: 0;
      top: 0.1em;
      width: 1em;
      height: 1em;
    }
  }
  .summary {
    clear: both;
    background: $light-bg-color;
    border: 0;
    padding: 0 rem(16);
    margin-bottom: rem(32);
    @include media('<=lg') {
      margin-left: rem(-16);
      margin-right: rem(-16);
    }
    &__item:last-child {
      border: 0;
    }
  }
  &__supports {
    @include media('>lg') {
      display: flex;
    }
  }
  &__support {
    @include media('>lg') {
      flex: 1 1;
    }
    @include font-primary(bold);
    color: $secondary-text-color;
    font-size: rem(22);
    text-align: center;
    margin: rem(32) 0 0;
    img {
      display: block;
      margin: 1em auto;
    }
  }
  &__terms-text {
    @include font-primary(bold);
    font-size: rem(16);
    color: $secondary-text-color;
    margin: rem(24) 0;
    a {
      @include font-primary;
      color: $primary-color;
    }
  }
  &__sign {
    margin: rem(24) 0;
    .svg-bankid {
      width: 42px;
      float: left;
      margin: 10px 36px 10px 26px;
    }
    .svg-arrow {
      float: right;
      margin: 22px;
    }
    .button-bankId {
      width: 100%;
      border: 1px solid #d6d6d6;
      border-radius: 3px;
      display: block;
      float: left;
      cursor: pointer;
      margin-bottom: 1rem;
      &:hover {
        border-color: #000000;
      }
    }
    .button-bankId-text {
      float: left;
      padding-top: 19px;
    }
    &.disabled{
      .button-bankId {
        opacity: .5;
        cursor: not-allowed;
        &:hover {
          border-color: #d6d6d6;
        }
      }
    }
  }
  &__send-submit {
    display: block;
    width: 100%;
  }
  &__disclaimer {
    @include font-primary(light);
    font-size: rem(13);
    color: $secondary-text-color;
    margin: rem(24) 0;
    a {
      color: $primary-color;
    }
  }
}

.betalsatt {
  .autogiro {
    text-align: left;
  }
  &__info-text {
    font-size: 16px;
    text-align: center;
    margin-bottom: 30px;
  }
  &__title {
    text-align: center;
    margin: 0 0 rem(30);
    @include font-primary;
    @include media('>lg') {
      font-size: rem(26);
    }
    @include media('<=lg') {
      font-size: rem(22);
      line-height: (36/22);
    }
  }
  &__block {
    margin-bottom: rem(20);
  }
  &__block > p {
    margin-top: 0px;
  }
&__block > h2 {
    @include font-primary(bold);
    margin: 0 0 rem(12);
    color: $secondary-text-color;
    @include media('>lg') {
      font-size: rem(22);
    }
    @include media('<=lg') {
      font-size: rem(18);
    }
}
  &__block-title {
    @include font-primary(bold);
    color: $secondary-text-color;
    margin: 0 0 rem(6);
    font-size: rem(18);
  }
  &__block-subtitle {
    @include font-primary(roman);
    margin: 0;
    margin: 0 0 rem(16);
    font-size: rem(16);
  }
  &__field-wrapper {
    position: relative;
    display: block;
    margin-bottom: rem(16);
  }
  &__field {
    position: absolute;
    opacity: 0;
  }
  &__field-content {
    border: 2px solid $light-border-color;
    border-radius: 3px;
    display: block;
    text-align: left;
    margin-top: 30px;
  }
  /*&__field:focus + &__field-content,
  &__field-content:hover {
    border-color: $dark-border-color;
  }*/
  &__field:checked + &__field-content,  &__field__checked{
    border-color: $primary-color;
    border-width: 2px;
  }
  &__field-label {
    display: block;
    @include font-primary;
    font-size: rem(18);
    padding: rem(19);
    &--with-info {
      display: flex;
    }
  }
  &__field-label-text {
    flex: 1 1;
  }
  &__field-label-info {
    font-size: rem(16);
  }
  &__field:checked + &__field-content &__field-label {
    @include font-primary(bold);
  }
  &__field-wrapper--asap-false &__field-content {
    display: flex;
    align-items: center;
  }
  &__field-wrapper--asap-false &__field-label {
    flex: 1 1;
  }
  &__field-wrapper--asap-false &__field-extra {
    position: relative;
    z-index: 1;
    right: rem(16);
  }
  &__calendar-wrapper {
    display: inline-block;
  }
  &__calendar#{&}__calendar { // double class to have more specificity than default styles
    right: 0;
    top: 0;
    padding: 1em;
    border: 0;
    box-shadow: 0 0 8px 3px rgba(0, 0, 0, 0.06);
    color: $secondary-text-color;
    header {
      @include font-primary(bold);
      font-size: 1em;
    }
    .cell {
      &.day {
        @include font-primary(roman);
        position: relative;
        z-index: 1;
        font-size: ((13/18) * 1em);
        border: 1px solid;
        margin: -1px 0 0 -1px;
        width: calc((100% / 7) + 1px);
        &.blank {
          border-color: transparent;
        }
        &:not(.disabled):not(.blank):hover {
          border-color: $primary-color;
          z-index: 2;
        }
      }
      &.selected {
        background-color: $primary-color;
        border-color: $primary-color;
        color: #fff;
        z-index: 2;
      }
      &.disabled {
        color: $light-border-color;
      }
      &.day-header {
        font-size: ((11/18) * 1em);
      }
    }
  }
  &__calendar-action {
    display: inline-block;
    line-height: 1;
    svg {
      display: inline-block;
      width: 1.2rem;
      height: 1.2rem;
      margin-left: 0.6rem;
      vertical-align: -0.2rem;
    }
  }
  &__date-field {
    opacity: 0;
    position: absolute;
    right: 0;
  }
  &__price-monitor-title {
    @include font-primary(bold);
    font-size: rem(16);
    margin: 0;
    color: $secondary-text-color;
  }
  &__field-wrapper--price-monitor &__field-extra {
    padding: 0 rem(19) rem(19);
  }
}  
</style>
